module.exports = __webpack_public_path__ + "v2-assets/static/media/pin-ov-defaut.png";